<template>
  <el-dialog :append-to-body="true" :title="title" :visible.sync="dialogVisible" @close="$emit('update:visible',false)">
    <div class="dialog_conwrap">
      <el-form ref="form" :rules="rules" :model="formdata" label-width="120px">
        <el-form-item label="类目名称:" prop="name">
          <el-input v-model="formdata.name" class="w340"></el-input>
        </el-form-item>
      </el-form>
      <div class="table_wrap">
        <el-table border :data="tableData" style="width: 100%">
          <el-table-column label="规格名称">
            <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.attrname" placeholder="请勿超过20个字"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="规格项">
            <template slot-scope="scope">
              <el-tag
                :key="index"
                v-for="(tag,index) in scope.row.attrvalue"
                closable
                :disable-transitions="false"
                @close="handleClose(scope.row,tag.id,index)"
              >{{tag.name}}</el-tag>
              <el-input
                class="input-new-tag"
                v-if="scope.row.inputVisible"
                v-model="scope.row.inputValue"
                ref="saveTagInput"
                size="small"
                placeholder="请勿超过20个字"
                @keyup.enter.native="handleInputConfirm(scope.row)"
                @blur="handleInputConfirm(scope.row)"
              ></el-input>
              <el-button
                v-else
                class="button-new-tag"
                size="small"
                @click="showInput(scope.row)"
              >添加规格项</el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="60">
            <template slot-scope="scope">
              <el-button icon="el-icon-delete" type="text" @click="delrow(scope.row,scope.$index)"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="table_oper textcenter">
          <el-button @click="addrow">新增规格</el-button>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="save('form')">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import api from "@/api.js";
export default {
  name: "goodsSpecificationDialog",
  props: ["visible", "id"],
  watch: {
    visible() {
      this.dialogVisible = this.visible;
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      title: "新增类目",
      formdata: {
        name: ""
      },
      tableData: [],
      del_spec: [],
      del_item: [],
      lock: true,
      rules: {
        name: [{ required: true, message: "请输入类目名称", trigger: "blur" }]
      }
    };
  },
  created() {
    if (this.id) {
      this.title = "编辑类目";
      this.queryspecification();
    }
  },
  methods: {
    // 查询类目详情
    queryspecification() {
      let params = {
        cate_id: this.id
      };

      this.axios
        .post(api.goods_attr_detail, params)
        .then(response => {
          if (response.data.code == 0) {
            this.formdata.cate_id = response.data.info.id;
            this.formdata.name = response.data.info.name;
            this.translatedata(response.data.list);
          } else {
          }
        })
        .catch(() => {});
    },
    // 转换规格数据
    translatedata(data) {
      if (data && data.length > 0) {
        data.forEach(item => {
          let cateitem = {
            id: item.id,
            attrname: item.name,
            attrvalue: item.attr || [],
            inputVisible: false,
            inputValue: ""
          };
          this.tableData.push(cateitem);
        });
      }
    },
    handleClose(row, tagid, index) {
      if (tagid) {
        this.disableddel(tagid, 2, () => {
          row.attrvalue.splice(index, 1);
          this.del_item.push(tagid);
        });
      } else {
        row.attrvalue.splice(index, 1);
      }
    },

    showInput(row) {
      row.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm(row) {
      let inputValue = row.inputValue;
      if (inputValue) {
        row.attrvalue.push({ name: inputValue });
      }
      row.inputVisible = false;
      row.inputValue = "";
    },
    // 添加行
    addrow() {
      this.tableData.push({
        attrname: "",
        attrvalue: [],
        inputVisible: false,
        inputValue: ""
      });
    },
    // 删除行
    delrow(row, index) {
      if (row.id) {
        this.disableddel(row.id, 1, () => {
          this.tableData.splice(index, 1);
          this.del_spec.push(row.id);
        });
      } else {
        this.tableData.splice(index, 1);
      }
    },
    // 是否可以删除
    disableddel(id, type, fn) {
      let params = {
        id: id,
        type: type
      };
      this.axios
        .post(api.goods_attr_delete_check, params)
        .then(response => {
          if (response.data.code == 0) {
            fn();
          } else {
          }
        })
        .catch(() => {});
    },
    // 保存
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.lock) {
            this.lock = false;
            if (this.id) {
              this.submiteditsave();
            } else {
              this.submitsave();
            }
          }
        } else {
          return false;
        }
      });
    },
    // 获取规格规格项
    getattrlist() {
      let result = [];
      if (this.tableData && this.tableData.length > 0) {
        this.tableData.forEach(item => {
          let attritem = {
            attr_name: item.attrname,
            attr_value: this.translateattr(item.attrvalue)
          };
          if (item.id) {
            attritem.id = item.id;
          }
          result.push(attritem);
        });
      }
      return result;
    },
    // 转换规格项
    translateattr(attrlist) {
      let res = attrlist.map(attrvalue => {
        let attritem = {
          name: attrvalue.name
        };
        if (attrvalue.id !== undefined) {
          attritem.id = attrvalue.id;
        }
        return attritem;
      });
      return res;
    },
    // 提交保存
    submitsave() {
      let params = {
        name: this.formdata.name,
        attr_list: this.getattrlist()
      };
      this.axios
        .post(api.goods_attr_add, params)
        .then(response => {
          this.lock = true;
          if (response.data.code == 0) {
            this.dialogVisible = false;
            this.$emit("specificationsuccess");
          } else {
          }
        })
        .catch(response => {
          this.lock = true;
        });
    },
    // 提交保存
    submiteditsave() {
      let params = {
        cate_id: this.formdata.cate_id,
        name: this.formdata.name,
        attr_list: this.getattrlist(),
        del_spec: this.del_spec,
        del_item: this.del_item
      };
      this.axios
        .post(api.goods_attr_edit, params)
        .then(response => {
          this.lock = true;
          if (response.data.code == 0) {
            this.dialogVisible = false;
            this.$emit("specificationsuccess");
          } else {
          }
        })
        .catch(response => {
          this.lock = true;
        });
    }
  }
};
</script>

